import { render, staticRenderFns } from "./PassNewComponent.vue?vue&type=template&id=1a851511&"
import script from "./PassNewComponent.vue?vue&type=script&lang=js&"
export * from "./PassNewComponent.vue?vue&type=script&lang=js&"
import style0 from "./PassNewComponent.vue?vue&type=style&index=0&id=1a851511&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports